import './Astronauta.css'

function Astronauta() {
  return (
    <section className="sectionImgAstronauta">

        <img className="mate"src="img/Mateprogrmaacion.png" alt=""/>

        <img className='astron' src="img/libro-astronauta2.png" alt="" />

    </section>
  );
}

export default Astronauta;
